
import React, { useState, useEffect } from "react";
import "./contact.css";
import img1 from "../../assets/bg-discover.png";
import img2 from "../../assets/enquiry.png";
import AOS from "aos";
import "aos/dist/aos.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    try {
      const response = await fetch("https://sales.redite.in/php/sendemail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      console.log("Server response:", result);

      if (result.success) {
        setStatus("Mail sent successfully ✔");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("Failed to send mail ❌");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setStatus("Error sending mail ❌");
    }

    setLoading(false);
  };

  return (
    <section className="container enquiry-section">
      <div className="enquiry-left" data-aos="fade-right">
        <h1>Enquiry</h1>
        <p className="subtitle">
          “Reach out today – let’s make it happen with an exclusive offer!”
        </p>

        <form className="enquiry-form" onSubmit={handleSubmit}>
          <label>Name</label>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <label>Email</label>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <label>Message</label>
          <textarea
            name="message"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>

          <button type="submit" className="send-btn" disabled={loading}>
            {loading ? "Sending..." : "✈ Send"}
          </button>

          {status && <p className="form-status">{status}</p>}
        </form>
      </div>

      <div className="enquiry-right" data-aos="fade-left">
        <img src={img1} alt="Bottom" className="img-bottom1" />
        <img src={img2} alt="Overlay" className="img-top1" />
      </div>
    </section>
  );
}

export default Contact;
